var _a;
import { ConverterType } from '../domain';
export var fieldMask = (_a = {
        types: ['google.protobuf.FieldMask']
    },
    _a[ConverterType.TO_JSON] = {
        transform: function (val) { return val.join(','); },
        /**
         * This one handles cases where we have a repeated google.protobuf.FieldMask type,
         * so it will look like: [['foo', 'bar'], ['qux']].
         *
         * The problem is that the serializer detects it as an array with actual fields (strings),
         * while in practice it is an array of multiple google.protobuf.FieldMask.
         *
         * We should determine if the items are actual fields (so each item is a string),
         * or arrays of google.protobuf.FieldMask (so each item is array that has items with fields).
         *
         * Another approach could be marking on the schama itseld each field if it's a repeatable or not,
         * it's not a good appraoch, but as long as google.protobuf.FieldMask is our only issue, it's
         * not _that_ bad solution.
         */
        checkRepetable: function (val) {
            return val.some(function (v) { return Array.isArray(v); });
        },
    },
    _a[ConverterType.FROM_JSON] = {
        transform: function (val) {
            /**
             * Support Scala FW JSON mapping bug, for more details see:
             *
             * https://github.com/wix-private/server-infra/issues/17953
             */
            if (typeof val === 'object') {
                return val.paths;
            }
            return val.split(',');
        },
    },
    _a);
//# sourceMappingURL=field-mask.js.map